// extracted by mini-css-extract-plugin
export default {"container":"categoryList_container__ub5m+"};